import { render } from "./ModalComponent.vue?vue&type=template&id=622b4f34&ts=true"
import script from "./ModalComponent.ts?vue&type=script&lang=ts"
export * from "./ModalComponent.ts?vue&type=script&lang=ts"

import "./_assets/modal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__